// extracted by mini-css-extract-plugin
export default {"root":"DownloadAppButton__root--1xz_X","downloadAppIcon":"DownloadAppButton__downloadAppIcon--3t1Dk"};